import React from "react";
import '../desgin/Footer.css'
const Footer = () => {
    return (
        < >
            <div id="footer" className="conatiner mt-5">
                <p className="text text-center"> @ atlin copyright 2024</p>
            </div>
        </>
    )
};
export default Footer;